module.exports = __webpack_public_path__ + "img/fazhi.b2c8a3c1.png";